/**
 * To, Subject and Message — shared by Send now and a schedule. Recipients are
 * typed as a list separated by commas, spaces or new lines (up to 20).
 */

import type { ReactNode } from 'react';

import type { EmailFields as Fields } from './email-api.ts';

export const MAX_RECIPIENTS = 20;

export const splitRecipients = (text: string): string[] =>
  text
    .split(/[\s,;]+/)
    .map((item) => item.trim())
    .filter(Boolean);

export function EmailFields({
  value,
  recipientsText,
  onRecipientsText,
  onChange,
}: {
  value: Pick<Fields, 'subject' | 'message'>;
  recipientsText: string;
  onRecipientsText: (text: string) => void;
  onChange: (patch: Partial<Pick<Fields, 'subject' | 'message'>>) => void;
}): ReactNode {
  const count = splitRecipients(recipientsText).length;
  return (
    <>
      <label className="rs-field">
        To ({count} of up to {MAX_RECIPIENTS})
        <textarea
          rows={2}
          value={recipientsText}
          placeholder="owner@client.co.za, manager@client.co.za"
          aria-invalid={count > MAX_RECIPIENTS}
          onChange={(event) => onRecipientsText(event.target.value)}
        />
      </label>
      <label className="rs-field">
        Subject
        <input
          value={value.subject}
          maxLength={200}
          onChange={(event) => onChange({ subject: event.target.value })}
        />
      </label>
      <label className="rs-field">
        Message (optional)
        <textarea
          rows={4}
          maxLength={4000}
          value={value.message}
          onChange={(event) => onChange({ message: event.target.value })}
        />
      </label>
    </>
  );
}
